function Cancel(props)
{
    return(
<svg className={props.class?props.class:""} width="100%" height="100%" viewBox="0 0 16 16"><polygon points="11.62 3.81 7.43 8 11.62 12.19 10.09 13.71 4.38 8 10.09 2.29 11.62 3.81"/></svg>
    )
}

export default Cancel